import { createContext } from 'react'

// used to open the mobile menu (must also include in App.js)
export const MenuContext = createContext(null)